import { render, staticRenderFns } from "./ModalTaskList.vue?vue&type=template&id=655795e5&scoped=true"
import script from "./ModalTaskList.vue?vue&type=script&lang=js"
export * from "./ModalTaskList.vue?vue&type=script&lang=js"
import style0 from "./ModalTaskList.vue?vue&type=style&index=0&id=655795e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655795e5",
  null
  
)

export default component.exports